var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14643 1.44148C1.43932 1.14858 1.91419 1.14858 2.20709 1.44148L10.7071 9.9415C11 10.2344 11 10.7092 10.7071 11.0021C10.4142 11.295 9.9393 11.295 9.6464 11.0021L1.14643 2.50214C0.853533 2.20924 0.853533 1.73437 1.14643 1.44148Z",
    fill: "#017E89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1768 0.721741C10.591 0.721741 10.9268 1.05752 10.9268 1.47174V10.4718C10.9268 10.886 10.591 11.2218 10.1768 11.2218H1.17676C0.762538 11.2218 0.426758 10.886 0.426758 10.4718C0.426758 10.0575 0.762538 9.72178 1.17676 9.72178H9.4268V1.47174C9.4268 1.05752 9.7625 0.721741 10.1768 0.721741Z",
    fill: "#017E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFooter);
export default __webpack_public_path__ + "static/media/arrow-footer.894bb172748f682eced2e4e52dfbe10f.svg";
export { ForwardRef as ReactComponent };